import type { GtagFn } from './register-google-analytics-provider.utils'

let cpStreamConfigured = false

/**
 * Configures the CP GoKollab GA4 data stream (legacy CP_GOKOLLAB_GTagID) when a contact is known.
 * Mirrors clientportal-core enableAnalytics GoKollab branch.
 */
export function registerGokollabCpStream(
  gtag: GtagFn | undefined,
  cpStreamMeasurementId: string | undefined,
  contactId: string | undefined,
  sendEnabled = false
): void {
  if (!sendEnabled || !gtag || !cpStreamMeasurementId?.trim() || !contactId || cpStreamConfigured) {
    return
  }

  try {
    gtag('config', cpStreamMeasurementId, { user_id: contactId })
    cpStreamConfigured = true
  } catch (error) {
    console.error('[Analytics] GoKollab CP stream config failed:', error)
  }
}

/** Resets CP stream singleton so registerGokollabCpStream can run again (logout / tests). */
export function resetGokollabCpStream(): void {
  cpStreamConfigured = false
}
